import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  Accordion,
  Checkbox,
  InputItem,
  Button,
  Toast,
  Badge,
  WhiteSpace,
  WingBlank,
  ActionSheet,
} from "antd-mobile";
import { createForm } from "rc-form";
import axios from "@/service/axios";

const CheckboxItem = Checkbox.CheckboxItem;
const loginAdminMsg =
  sessionStorage.getItem("loginMsg") &&
  JSON.parse(sessionStorage.getItem("loginMsg"));

export class SetIccids extends Component {
  state = {
    iccidData: {},
    iccidPri: 0,
  };

  async componentDidMount() {
    this.getIccidInfo();
  }

  getIccidInfo() {
    axios.get("/api/user/ptt/card_info/get", {
      params: {
        uid: this.props.match.params.uid
      }
    }).then(res => {
      console.log(res);
      if (res && res.status == 200 && res.data) {
        this.setState({
          iccidData: res.data,
          iccidPri: res.data.iccidPri,
        });
      }
    }).catch(res => {
    });
  }

  //校验ICCID
  validateIccid = (rule, value, callback) => {
    let masterIccid = this.props.form.getFieldValue('masterIccid');
    let slaveIccid = this.props.form.getFieldValue('slaveIccid');
    let agentpwd = this.props.form.getFieldValue('agentpwd');
    if (masterIccid && !slaveIccid) {
      if (/^[a-zA-Z0-9]{19,20}$/.test(masterIccid)) {
        if (agentpwd) {
          callback();
        } else {
          callback(new Error("请填写经销商密码"));
        }
      } else {
        callback(new Error("请填写19~20位数字ICCID号码"));
      }
    // } else if (!masterIccid && slaveIccid) {
    //   if (/^[a-zA-Z0-9]{19,20}$/.test(slaveIccid)) {
    //     if (agentpwd) {
    //       callback();
    //     } else {
    //       callback(new Error("请填写经销商密码"));
    //     }
    //   } else {
    //     callback(new Error("请填写19~20位数字ICCID号码"));
    //   }
    } else if (masterIccid && slaveIccid) {
      if (/^[a-zA-Z0-9]{19,20}$/.test(masterIccid) && /^[a-zA-Z0-9]{19,20}$/.test(slaveIccid)) {
        if (masterIccid == slaveIccid) {
          callback(new Error("ICCID主卡不能与副卡一样"));
        } else {
          if (agentpwd) {
            callback();
          } else {
            callback(new Error("请填写经销商密码"));
          }
        }
      } else {
        callback(new Error("请填写19~20位数字ICCID号码"));
      }
    } else {
      callback();
    }
  };
  render() {
    const { iccidData, iccidPri } = this.state;
    const { dispatch, form, } = this.props;
    const { validateFields, getFieldProps, getFieldsValue, getFieldError, setFieldsValue } = form;

    const submit = () => {
      validateFields({ force: true }, (error, value) => {
        if (!error) {
          console.log(value);
          axios.post("/api/user/ptt/card_info/set", {
            ...value,
            uid: this.props.match.params.uid,
          }).then(res => {
            if (res.status == 200) {
              window.history.go(-1);
            } else {
              Toast.fail(res.message);
            }
          });
        }
      });
    };

    const onCheckIccidPri = (e) => {
      console.log(e.target.checked);
      setFieldsValue({
        iccidPri: e.target.checked ? 1 : 0,
      });
      this.setState({
        iccidPri: e.target.checked ? 1 : 0,
      });
    }

    return (
      <div className="setFunctions">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          功能设置
        </NavBar>
        <form>
          <div>
            <List
              renderFooter={() =>
                getFieldError("masterIccid") ||
                // getFieldError("slaveIccid") ||
                getFieldError("agentpwd")
              }
            >
              <List.Item>
                <InputItem
                  {...getFieldProps("masterIccid", {
                    rules: [{
                      validator: this.validateIccid,
                    }, {}],
                    initialValue: iccidData.masterIccid,
                  })}
                  clear
                  // type="number"
                  placeholder="请输入19位ICCID号码"
                  key="8"
                  minLength={19}
                  maxLength={20}
                >
                  <i className="red-star">*</i>
                  ICCID主卡
                </InputItem>
              </List.Item>
              <List.Item>
                <InputItem
                  {...getFieldProps("slaveIccid", {
                    // rules: [{
                    //   validator: this.validateIccid,
                    // }, {}],
                    initialValue: iccidData.slaveIccid,
                  })}
                  clear
                  // type="number"
                  placeholder="请输入19位ICCID号码"
                  key="8"
                  minLength={19}
                  maxLength={20}
                >
                  {/* <i className="red-star">*</i> */}
                  ICCID副卡
                </InputItem>
              </List.Item>
              <List.Item>
                <InputItem
                  {...getFieldProps("agentpwd", {
                    // rules: [{
                    //   validator: this.validateIccid,
                    // }, {}],
                    initialValue: iccidData.agentpwd,
                  })}
                  clear
                  type="password"
                  placeholder="请输入经销商密码"
                  key="9"
                  labelNumber="7"
                  maxLength={7}
                >
                  <i className="red-star">*</i>
                  经销商密码
                </InputItem>
              </List.Item>
              <List.Item>
                <CheckboxItem
                  {...getFieldProps("iccidPri", {
                    initialValue: iccidData.iccidPri || 0,
                  })}
                  checked={iccidPri == 1}
                  onChange={e => onCheckIccidPri(e)}
                >
                  优先使用ICCID登录
              </CheckboxItem>
              </List.Item>
            </List>
            <WhiteSpace size="lg" />
            <WingBlank>
              <Button onClick={submit} type="primary">
                确定
            </Button>
              <WhiteSpace size="lg" />
              <Button onClick={() => this.props.history.goBack()}>
                返回
            </Button>
            </WingBlank>
          </div>
        </form>
      </div>
    )
  }
}

export default createForm()(SetIccids);
